import { LeadTypes } from '@components/pages/CorporateLanding/CorporateLeadForm';
import { api_create_corporate_lead_path } from '@routes';

import request from './request';

export interface CreateCorporateLeadParams {
  corporate_lead: {
    company_name?: string;
    email: string;
    job_title?: string;
    lead_type: LeadTypes;
    name?: string;
    phone_number?: string;
    possible_number_of_users?: string;
    recaptcha_token?: string;
  };
}

export interface CreateCorporateLeadResponse {
  success: boolean;
  existingEntries: boolean;
}

export async function createCorporateLead(
  params: CreateCorporateLeadParams
): Promise<CreateCorporateLeadResponse> {
  const res = await request('post', api_create_corporate_lead_path(params));
  return res;
}
